module.exports = __webpack_public_path__ + "static/img/cancerscem.2fd9615.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cancerscem.png
// module id = AEWN
// module chunks = 1